import { ReportService } from '@/app/reports/share/report.service'
import { ref } from '@vue/composition-api'
import store from '@/store'
import {devices,owners,contracts,reFilterDevices} from '@/app/reports/share/helper'

export default function reportForm() {

  // const devices = ref([])
  // const  owners=ref([]);
  // const contracts=ref([]);

  const searchoperations=ref([


    {
      id:">",
      name:'greater than'
    },
    {
      id:"<",
      name:"less than"
    },
    {
      id:"=",
      name:"equal"
    }

  ]);

  
  const categoriesOptionsByGeofence=ref([])
  const type = ref('inside')
  const start_trip=ref('');
  ReportService.getDevicesOptions({
    type:'device',
    user: store.state.auth.userData.id
  }).then(response => devices.value = response.data.map((d)=>({id:d.device_id,"name":d.name})))



  ReportService.getDevicesOptions({
    type:'user',
    user: store.state.auth.userData.id
  }).then(response =>{ owners.value = response.data})


  
  ReportService.getDevicesOptions({
    type:'contract',
    user: store.state.auth.userData.id
  }).then(response =>{
    // console.log("contracrs",response.data), W
  
  contracts.value = response.data})


  return {
    devices,
    owners,
    contracts,
    searchoperations,
    reFilterDevices
   
  }
}
